import { render } from "./IconInvestedRoundedType5.vue?vue&type=template&id=29decc50&ts=true"
import script from "./IconInvestedRoundedType5.vue?vue&type=script&lang=ts"
export * from "./IconInvestedRoundedType5.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__